import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { useMatchMedia } from '@xing-com/crate-hooks-use-match-media';
import {
  FeedbackButton,
  FeedbackButtonExpression,
} from '@xing-com/feedback-button';
import { mediaConfined } from '@xing-com/layout-tokens';
import { motionEasingStandard, motionTimeXXS } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

export type FeedbackVariant = 'like' | 'neutral' | 'dislike';

type Props = {
  variant: FeedbackVariant;
  onClick: (feedback: FeedbackVariant) => void;
};

const EXPRESSION: Record<FeedbackVariant, FeedbackButtonExpression> = {
  like: 'very-happy',
  neutral: 'neutral',
  dislike: 'sad',
};

const A11Y_LABEL: Record<FeedbackVariant, string> = {
  like: 'JOBS_SEARCH_AI_FEEDBACK_LIKE_A11Y_LABEL',
  neutral: 'JOBS_SEARCH_AI_FEEDBACK_NEUTRAL_A11Y_LABEL',
  dislike: 'JOBS_SEARCH_AI_FEEDBACK_DISLIKE_A11Y_LABEL',
};

export const ColorFeedback: React.FC<Props> = ({ variant, onClick }) => {
  const { formatMessage } = useIntl();
  const isBigScreen = useMatchMedia(mediaConfined);

  const handleOnClick = (): void => {
    onClick(variant);
  };

  return (
    <Button
      variant="primary"
      expression={EXPRESSION[variant]}
      aria-label={
        isBigScreen ? undefined : formatMessage({ id: A11Y_LABEL[variant] })
      }
      onClick={handleOnClick}
    >
      {isBigScreen ? (
        <BodyCopy noMargin>
          <FormattedMessage id={A11Y_LABEL[variant]} />
        </BodyCopy>
      ) : null}
    </Button>
  );
};

const Button = styled(FeedbackButton)`
  svg {
    transition: transform ${motionTimeXXS} ${motionEasingStandard};
  }

  &:hover svg {
    transform: scale(1.1);
  }
`;
